var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 5.95889L7.11076 5.10909C6.63809 4.65738 6.01715 4.3844 5.33331 4.3844C3.86055 4.3844 2.66665 5.6592 2.66665 7.23175C2.66665 9.36696 3.55981 10.9418 4.68814 12.1079C5.83624 13.2944 7.18652 14.0073 7.92376 14.3355C7.97502 14.3583 8.02494 14.3583 8.0762 14.3355C8.81343 14.0073 10.1637 13.2944 11.3118 12.1079C12.4401 10.9418 13.3333 9.36701 13.3333 7.23178C13.3333 5.65923 12.1394 4.3844 10.6666 4.3844C9.98281 4.3844 9.36187 4.65738 8.8892 5.10909L7.99998 5.95889ZM7.99998 4.04826C7.2923 3.37196 6.35779 2.96072 5.33331 2.96072C3.12417 2.96072 1.33331 4.87293 1.33331 7.23175C1.33331 12.4645 5.78095 14.924 7.41066 15.6495C7.79029 15.8185 8.20967 15.8185 8.5893 15.6495C10.219 14.924 14.6666 12.4646 14.6666 7.23179C14.6666 4.87297 12.8758 2.96072 10.6666 2.96072C9.64217 2.96072 8.70766 3.37196 7.99998 4.04826Z",
    fill: "#031D42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartEmpty);
export default __webpack_public_path__ + "static/media/heart-empty.666e9e5b.svg";
export { ForwardRef as ReactComponent };